exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton + button {\r\n  margin-left: 10px;\n}\n.dynamic-delete-button {\r\n  margin-left: 10px;\n}\r\n", ""]);

// exports
